<tds-button #triggerBtn id="fake-trigger" style="display: none;">Abrir modal</tds-button>

<tds-modal
  selector="#fake-trigger"
  [header]="modalTitle"
  size="sm"
  actions-position="static"
>
  <span slot="body">
    <ng-content></ng-content>
  </span>
  
  <span slot="actions">
    <ng-content select="[modal-actions]"></ng-content>
  </span>
</tds-modal>